module.exports = __webpack_public_path__ + "static/media/goblin_big_momma_circle.81bb32fe.svg";